import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import BlogCard from "../../Components/Cards/Blog";
import Loading from "../../Components/Loading";
import Paginate from "../../Components/Paginate";
import { useBlogList } from "./Hooks";

const List = () => {
  const empty = () => {
    return <h4 className="text-center my-5">مقاله ایی یافت نشد</h4>;
  };
  const filters = [{ key: "page" }, { key: "category_id" }, { key: "title" }];
  const { data, loading, searchParams, changeObj } = useBlogList({
    filters,
  });

  // console.log("d", data);
  return (
    <>
      <Helmet>
        <title>مقالات | صنعتبان </title>

        <meta name="description" content={" مجله صنعتبان"} />
        <link rel="canonical" href={window.origin + "/blogs"} />
      </Helmet>
      <div>
        <div style={{ marginBottom: "20px" }}>
          <section>
            <div className="container">
              <div className="row">
                <div className="col-12 web-template" style={{}}>
                  <div className="row pb-3 title-border " style={{}}>
                    <div className="col-md-6 col-4">
                      <h1
                        style={{
                          fontSize: "23px",
                        }}
                      >
                        همه مقالات
                      </h1>
                    </div>
                    <div className="col-md-6 col-8">
                      <div className="row justify-content-end ">
                        <div className="col-lg-6">
                          <div
                            className="d-flex  "
                            style={{
                              borderRadius: "15px",
                              boxShadow:
                                " rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px",
                              marginRight: "10px",
                              overflow: "hidden",
                              display: "flex",
                            }}
                          >
                            <input
                              className="border-0 py-2 px-3"
                              placeholder="جست و جو در مقالات"
                              style={{ flex: 1 }}
                              onChange={({ target: { value } }) => {
                                changeObj("title", value);
                              }}
                            />
                            <button
                              className="btn btn-blue px-3"
                              style={{
                                borderRadius: "15px",
                              }}
                            >
                              <img
                                // src={require("/WebSide/assets/images/search.png")}
                                src={require("../../Assets/images/search.png")}
                                alt="همه ملاقات"
                                style={{ width: "20px", height: "20px" }}
                              />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex align-items-center mt-3 flex-wrap">
                    {loading ? (
                      <Loading />
                    ) : (
                      <>
                        <button
                          className={`${
                            searchParams.get("category_id")
                              ? "btn-blog-category"
                              : "btn-blog-category-select"
                          }`}
                          style={{ marginLeft: "10px" }}
                          onClick={() => {
                            changeObj("category_id", "");
                          }}
                        >
                          همه مقالات
                        </button>
                        {data?.categoires?.map((cat, i) => {
                          return (
                            <button
                              onClick={() => {
                                // Handler({ category_id: cat.id });
                                changeObj("category_id", cat.id);
                              }}
                              key={i}
                              className={`${
                                cat.id == searchParams.get("category_id")
                                  ? "btn-blog-category-select"
                                  : "btn-blog-category"
                              }`}
                              style={{ marginLeft: "10px" }}
                            >
                              {cat.title}
                            </button>
                          );
                        })}
                      </>
                    )}
                  </div>
                  <div className="row">
                    {loading ? (
                      <Loading count={6} col={4} height={320} />
                    ) : data?.blogs?.data.length > 0 ? (
                      data &&
                      data?.blogs.data?.map((item, id) => {
                        return <BlogCard blog={item} key={id} />;
                      })
                    ) : (
                      empty()
                    )}
                  </div>
                </div>
              </div>
              <Paginate
                data={data.blogs}
                loading={loading}
                filters={filters}
                searchParams={searchParams}
              />
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default List;
